<template>
    <NuxtLayout name="casino">
        <div class="plinko-game q-px-md">
            <!-- 游戏展示区 -->
            <div class="h-fit full-width bg-keep-orange pr-6 pl-6 plinko-main">
                <ClientOnly fallback-tag="span">
                    <GameSettingsDiceTabsWrapper class="flex !justify-end !mb-3">
                        <GameSettingsButtonLiveChat
                            v-if="userStore.isLoggedIn"
                            v-model="isOpenLiveChat"
                        />
                        <GameSettingsButtonAnimate v-model="settingStore.animation" />
                        <GameSettingsButtonFast
                            v-model="gameStore.plinko.fast"
                            :gameName="'plinko'"
                            :isBetting="slowGaming.size > 0"
                        />
                        <GameSettingsButtonFairness v-model="isOpenFairness" />
                        <GameSettingsButtonRule v-model="isOpenRule" name="plinko" />
                        <GameSettingsButtonVocie
                            v-model="settingStore.inhouseGames.sound.on"
                            v-model:voice-model-value="settingStore.inhouseGames.sound.music"
                            :saveAfterChange="true"
                        />
                    </GameSettingsDiceTabsWrapper>
                </ClientOnly>
                <div class="plinko-content">
                    <!-- 小球掉落区域 start -->
                    <div class="game-field">
                        <img src="" alt="" class="game-bg" />
                        <canvas ref="plinkoCanvas" id="plinko" width="682" height="501"></canvas>
                        <ClientOnly>
                            <plinkoMultiRows
                                :odds="odds"
                                :rowsModel="rowsModel"
                                :riskModel="riskModel"
                                :active="active"
                                :oForm="oForm"
                                :activeBall="activeBall"
                            />
                        </ClientOnly>
                    </div>
                    <!-- 小球掉落区域 end -->
                    <!-- top middle 最大分发 start -->
                    <!-- ↓ 关闭，在迷你版中改用弹出提示 -->
                    <!-- <div class="plinko-maxwin" v-if="showMaxWin">
                        {{ $t('maxPayout') }}
                        <span>{{ joinStore?.config[settingStore.pickedCurrency]?.maxWin }} {{ settingStore.pickedCurrency.toLocaleUpperCase() }}</span>
                    </div> -->
                    <!-- top middle 最大分发 end -->
                    <ClientOnly>
                        <!-- 左上角区域 start -->
                        <plinkoJackpot
                            :modalVisible="modalVisible"
                            @handleModal="handleModal"
                            :jackpotSize="globalStore?.jackpotSum['plinko']"
                            :jackpot="jackpot"
                        />
                        <!-- 左上角区域 end -->
                        <!-- 右上角区域 历史记录 start -->
                        <plinkoResultHistory :odds="odds" :riskOptions="riskOptions" />
                        <!-- 右上角区域 end -->
                    </ClientOnly>
                </div>
            </div>
            <!-- 
                ↑ 以上是游戏舞台 
                ↓ 游戏的表单 
            -->
            <ClientOnly>
                <!-- 投注选项区域 -->
                <div class="px-3 game-container">
                    <CasinoBetOptionSection
                        v-if="autoBetToolKit || betTookit"
                        :betTookit="betTookit"
                        :auto-bet-tool-kit="autoBetToolKit"
                        v-model:bet-amount-modal-value="oForm.amount"
                        v-model:is-submiting="oForm.isSubmiting"
                        :sound="settingStore.sound"
                        :is-auto="gameStore?.plinko.auto.default"
                        :bet-submit="betSubmit"
                        :is-fast="gameStore?.plinko.fast"
                        class="game-body !mt-0"
                        @change-mode="toChangeMode"
                    />
                </div>
            </ClientOnly>
            <ClientOnly>
                <!-- 玩家选择难度 -->
                <div class="q-mt-md px-3 game-container">
                    <div
                        class="full-width row items-center justify-center text-center game-body gap-2"
                    >
                        <!-- 风险选择 start -->
                        <div class="col column">
                            <div class="rounded-borders">
                                <DropDown
                                    v-if="dropDownRiskOptions.length > 0"
                                    v-model="riskModel"
                                    :options="dropDownRiskOptions"
                                    @update:model-value="(value) => handleUpdate(value)"
                                    :disabled="stageHasBall || oForm.isSubmiting"
                                    :label="`${$t('risk')}：`"
                                >
                                    <template #prevIcon>
                                        <p v-html="riskSvg"></p>
                                    </template>
                                </DropDown>
                            </div>
                        </div>
                        <!-- 风险选择 end -->
                        <!-- 行数选择 start -->
                        <div class="col column">
                            <div class="rounded-borders">
                                <DropDown
                                    v-if="odds.dropDownrowsOptions.length > 0"
                                    v-model="rowsModel"
                                    :options="odds.dropDownrowsOptions"
                                    @update:model-value="(value) => handleRows(value)"
                                    :disabled="stageHasBall || oForm.isSubmiting"
                                    :label="`${$t('rows')}：`"
                                >
                                    <template #prevIcon>
                                        <!-- 占位 -->
                                        <span></span>
                                    </template>
                                </DropDown>
                            </div>
                        </div>
                        <!-- 行数选择 end -->
                    </div>
                </div>
            </ClientOnly>
            <ClientOnly>
                <!-- 自动 -->
                <CasinoAutoSection
                    :ref="(el) => (autoDialog = el)"
                    v-model:amount="oForm.amount"
                    :is-fast="gameStore.plinko.fast"
                    :is-submiting="oForm.isSubmiting"
                    :is-auto="gameStore.plinko.auto.default"
                    class="auto-section"
                />
            </ClientOnly>
        </div>
        <ModalWinJackpot v-model="winJackpotVisible" :data="winJackpotData" />
    </NuxtLayout>
</template>

<script>
import { defineComponent } from 'vue';
// socket
import { useGameSocket } from '@/socket/game';
import { useTrackerSocket } from '~/socket/tracker';
import { useJackPotSocket } from '@/socket/jackpot';
// stores
import { usePlinkoStore } from '~/stores/cansino/plinko';
import { useUserStore } from '~/stores/user';
import useSettingsStore from '~/stores/settings';
import { useGameHistoryStore } from '@/stores/cansino/gameHistory';
import { useJoinStateStore } from '@/stores/cansino/joinState';
import useGlobalStore from '@/stores/global';
// components
import plinkoJackpot from './_components/jackpot/index.vue';
import plinkoResultHistory from './_components/resultHistory/index.vue';
import plinkoMultiRows from './_components/multiRows/index.vue';
// function
import { useBettingToolkit } from '~/common/js/bettingToolkit';
import { useAutoBetToolKit } from '~/common/js/bettingToolkit/auto';
import PlinkoGame from './js/plinkoGame';
import { handleSetInterval } from './js/module.js';
import { showTips4BadAmountIfNeeded } from '@/common/js/betHelper';
// mock data
import { oddsData, fnDataSetter } from './data/oddsData';
// assets
import plinkoBg from '@/assets/mp3/plinko/plinko_bg.mp3';
import plinkoB1 from '@/assets/mp3/plinko/plinkoB1.mp3';
import plinkoB2 from '@/assets/mp3/plinko/plinkoB2.mp3';
import plinkoB3 from '@/assets/mp3/plinko/plinkoB3.mp3';
import plinkoB4 from '@/assets/mp3/plinko/plinkoB4.mp3';
import plinkoB5 from '@/assets/mp3/plinko/plinkoB5.mp3';
import plinkoB6 from '@/assets/mp3/plinko/plinkoB6.mp3';

export default defineComponent({
    name: 'plinkoGame',
    components: {
        plinkoJackpot,
        plinkoResultHistory,
        plinkoMultiRows,
    },
    props: [],
    data() {
        const { t: $tFn } = useNuxtApp().$i18n;
        return {
            autoBetToolKit: null,
            betTookit: null,
            riskModel: 'Medium', //风险
            riskOptions: ['Low', 'Medium', 'High'],
            dropDownRiskOptions: [
                {
                    name: $tFn('commonInfo.riskLow'),
                    value: 'Low',
                },
                {
                    name: $tFn('commonInfo.riskMedium'),
                    value: 'Medium',
                },
                {
                    name: $tFn('commonInfo.riskHigh'),
                    value: 'High',
                },
            ],
            rowsModel: 16, // 行数
            odds: oddsData,
            // Select svg-icon
            riskSvg:
                '<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.5" cy="8.5" r="8.5" fill="url(#radialPlinko)"></circle><defs><radialGradient id="radialPlinko" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.5 8.5) rotate(90) scale(8.5)"><stop stop-color="#5CCE03"></stop><stop offset="0.697917" stop-color="#F2E407"></stop><stop offset="1" stop-color="#D1FF50"></stop></radialGradient></defs></svg>',
            modalVisible: false,
            oForm: {
                amount: 0, // 将被赋值 
                isSubmiting: false,
            },
            gameStore: useSettingsStore().game,
            settingStore: useSettingsStore(),
            userStore: useUserStore(),
            joinStore: useJoinStateStore(),
            globalStore: useGlobalStore(),
            plinkoGames: null, // canvas 实例
            hasBall: false, // 游戏区是否有小球
            updateTimer: null,
            historyTimer: null,
            active: [],
            activeBall: {},
            // 数组中 1 的个数，就是小球落到的位置下标。比如有5个1，则小球会在第六个缝隙落下
            rollArray: [0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 1, 1, 0, 0, 0],
            isOpenLiveChat: false, // 右侧统计
            isOpenFairness: false, // 公平性弹框
            isOpenRule: false, // 规则弹框
            onBetHistory: [],
            musicControler: null,
            soundOption: {
                // 音效配置
                plinkoBg: {
                    src: plinkoBg,
                    loop: true,
                    isBGM: true,
                    volume: useSettingsStore().inhouseGames.sound.music,
                },
                plinkoB1: {
                    src: plinkoB1,
                },
                plinkoB2: {
                    src: plinkoB2,
                },
                plinkoB3: {
                    src: plinkoB3,
                },
                plinkoB4: {
                    src: plinkoB4,
                },
                plinkoB5: {
                    src: plinkoB5,
                },
                plinkoB6: {
                    src: plinkoB6,
                },
            },
            autoDialog: null,
            winJackpotVisible: false,
            winJackpotData: {},
            jackpot: [], // 需要等球落完后再取值更新
            jackpotRecords: {}, // 暂存jackpot数据
            jackpotListeningStoper: ()=>{}, // 稍后赋值
            slowGaming: new Set([]),
        };
    },
    computed: {
        // 游戏区是否有球
        stageHasBall() {
            console.log(usePlinkoStore().stageHasBall, 'usePlinkoStore().stageHasBall');
            return usePlinkoStore().stageHasBall;
        },
        gameHistory() {
            const { gameHistoryDelay } = useGameHistoryStore();
            // 路由切换到别的游戏后，还会触发computed-gameHistory，防止这种问题出现
            if (this.joinStore.gameOfRoute !== 'plinkoGame') {
                return;
            }
            return gameHistoryDelay;
        },
        // 显示最大分发金额
        // showMaxWin(){
        //     return this.joinStore?.config[this.settingStore.pickedCurrency]?.maxBets[0] === Number(this.oForm.amount)
        // },
        // ↓ 用户期待的提现金额 
        expectedReward(){
            const arr = this.odds[this.riskModel]?.[this.rowsModel];
            if (!arr) return 0; 
            const aMulti = arr.map(cur => cur.mutil);
            const fMaxMulti = Math.max(...aMulti); 
            const formAmount =  Number(this.oForm.amount);
            const fResult = formAmount * fMaxMulti;
            return fResult;
        },
    },
    watch: {
        expectedReward(newVal){
            showTips4BadAmountIfNeeded(newVal);
        },
        // 监听音效开关 是否播放背景音乐
        'settingStore.inhouseGames.sound.on': {
            handler(newVal) {
                if (import.meta.server) return; 
                if (newVal) {
                    if (!this.musicControler) {
                        // 音效初始化
                        this.musicControler = new MusicControler(this.soundOption);
                    }

                    this.musicControler.oAudio.plinkoBg?.toPlay();
                } else {
                    this.musicControler && this.musicControler.oAudio.plinkoBg?.stop();
                }
            },
            immediate: true,
        },
        'winJackpotVisible'(newVal, oldVal) {
            if (oldVal && oldVal !== newVal) {
                this.winJackpotData = {};
            }
        },
        'joinStore.hasGameInfoLoaded':{
            handler(bNew){
                if (import.meta.server || !bNew) return;
                const { wins_map=[] } = this.joinStore.config;
                if (!wins_map.length) return;
                fnDataSetter(this.odds, wins_map);
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        this.handleResize();
        this.handleUpdate(this.riskModel);
        this.autoBetToolKit = useAutoBetToolKit(this.oForm, this.betSubmit);
        this.betTookit = useBettingToolkit(this.oForm);

        // 初始化canvas（等待 DOM 挂载完成）
        this.$nextTick(() => this.initCanvas());
        this.handleOnWinJackpot();
        this.jackpot = this.joinStore?.jackpot;
        onUnmounted(() => {
            this.musicControler?.toDestory();
            this.updateTimer && clearInterval(this.updateTimer);
            this.historyTimer && clearTimeout(this.historyTimer);
            this.jackpotListeningStoper?.();
        });
    },
    methods: {
        /**
         * 获取下注结果
         * @param {number} index 当前倍数对应的下标
         * @param {string} hash 本局下注对应的hash
         */
        async setResult(index, hash, ts) {
            const plinkoStore = usePlinkoStore();
            // this.active.push(index);
            this.activeBall[hash] = index;
            // 播放声音
            const ind = this.odds.sounds[this.rowsModel][index] + 1;
            this.musicControler?.oAudio[`plinkoB${ind}`]?.toPlay();
            // 等待小球下落后清空
            setTimeout(() => {
                delete this.activeBall[hash];
            }, 200);
            setTimeout(()=>{
                this.joinStore.showDateInQueue(); // 插入游戏结果并播放动画
                this.userStore.queueForward(ts); // 显示余额变化
            }, this.gameStore.plinko.fast ? 500 : 0);
            // jackpot相关
            this.jackpot = this.jackpotRecords[hash];

            if (Object.keys(this.winJackpotData).length) {
                this.winJackpotVisible = true;
            }

            plinkoStore.stageHasBall = this.plinkoGames.hasBall();
            plinkoStore.canBet = true;
            if (!this.gameStore?.plinko.auto.default) {
                this.joinStore.gameRunning = false;
            }
        },
        /**
         * 下注
         */
        async betSubmit() {
            const { currencies, currentCurrency } = this.userStore;
            if (!currencies[currentCurrency].balance) {
                return;
            }
            this.joinStore.gameRunning = true;
            const plinkoStore = usePlinkoStore();
            const { EMIT_PLINKO_BET } = useGameSocket();
            const { EMIT_TRACKER_EVENT } = useTrackerSocket();
            const params = {
                sector: this.riskOptions.indexOf(this.riskModel),
                amount: getFixed(this.oForm.amount),
                isFast: this.gameStore.plinko.fast,
                rows: this.rowsModel,
                frontID: new Date().getTime(),
            };
            // if (import.meta.env.DEV_MODE && Math.random() <= 0.3){ 
            //     params.amount = 0; 
            // }
            try {
                const ts = this.userStore.queueStart(false); // 防止余额立即变化
                EMIT_TRACKER_EVENT(
                    { eventType: 'Bet' },
                    (e) => console.log(e),
                );
                const res = await EMIT_PLINKO_BET(params);
                // console.log('plinko bet res ↓\n', deepCopy(res));
                // 下注请求异常
                if (!res || res?.code || res?.error) {
                    this.userStore.queueDelete(ts);
                    if (!this.gameStore?.plinko.auto.default){
                        showNegativeNotify(res?.error);
                    }
                    this.joinStore.gameRunning = false;
                } else {
                    const multiIndex = res.roll_array.filter((item) => item == 1).length;
                    this.jackpotRecords[res.hash] = this.joinStore?.jackpot;
                    if (this.gameStore.plinko.fast) {
                        // 快速下注模式
                        await this.setResult(multiIndex, res.hash, ts);
                        // 防止连点下注
                        await Sleep(500);
                    } else {
                        const {oPromise, resolve} = createPromise();
                        const t01 = Date.now();
                        this.slowGaming.add(t01);
                        this.plinkoGames.addBall(
                            multiIndex,
                            async (ball) => {
                                ball.free = true;
                                await this.setResult(multiIndex, res.hash, ts);
                                plinkoStore.stageHasBall = this.plinkoGames.hasBall();
                                const iSeconds = ((Date.now() - t01) / 1000).toFixed(1);
                                console.log(`小球落地 ${iSeconds}s`);
                                this.slowGaming.delete(t01);
                                resolve();
                            },
                            this.riskModel.toLocaleLowerCase(),
                        );
                        plinkoStore.stageHasBall = true;
                        plinkoStore.canBet = false;
                        if (this.gameStore.plinko.auto.default){
                            await oPromise;
                        }else{
                            await Sleep(500); // 防止连点下注
                        }
                    }
                }
                return res;
            } catch (err) {
                console.log('error', err);
                this.joinStore.gameRunning = false;
            }
        },
        /**
         * 风险切换选择
         * @param {String} value risk
         */
        handleUpdate(value) {
            const val = value && typeof value === 'object' ? value.value : value;
            this.riskModel = val;
            switch (val) {
                case 'High':
                    this.riskSvg =
                        '<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.5" cy="8.5" r="8.5" fill="url(#radialPlinko)"></circle><defs><radialGradient id="radialPlinko" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.5 8.5) rotate(90) scale(8.5)"><stop stop-color="#FF9900"></stop><stop offset="0.697917" stop-color="#FFC700"></stop><stop offset="1" stop-color="#FF3D00"></stop></radialGradient></defs></svg>';
                    break;
                case 'Medium':
                    this.riskSvg =
                        '<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.5" cy="8.5" r="8.5" fill="url(#radialPlinko)"></circle><defs><radialGradient id="radialPlinko" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.5 8.5) rotate(90) scale(8.5)"><stop stop-color="#5CCE03"></stop><stop offset="0.697917" stop-color="#F2E407"></stop><stop offset="1" stop-color="#D1FF50"></stop></radialGradient></defs></svg>';
                    break;
                case 'Low':
                    this.riskSvg =
                        '<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.5" cy="8.5" r="8.5" fill="url(#radialPlinko)"></circle><defs><radialGradient id="radialPlinko" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.5 8.5) rotate(90) scale(8.5)"><stop stop-color="#43BBFF"></stop><stop offset="0.697917" stop-color="#6AF6FF"></stop><stop offset="1" stop-color="#4478FF"></stop></radialGradient></defs></svg>';
                    break;
                default:
                    this.riskSvg =
                        '<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.5" cy="8.5" r="8.5" fill="url(#radialPlinko)"></circle><defs><radialGradient id="radialPlinko" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.5 8.5) rotate(90) scale(8.5)"><stop stop-color="#43BBFF"></stop><stop offset="0.697917" stop-color="#6AF6FF"></stop><stop offset="1" stop-color="#4478FF"></stop></radialGradient></defs></svg>';
            }
        },
        /**
         * 行数选择
         * @param {Number} value rows
         */
        handleRows(value) {
            this.rowsModel = value;
            this.plinkoGames.newGame(value);
        },
        /**
         * jackpot modal 显示、隐藏
         */
        handleModal() {
            this.modalVisible = !this.modalVisible;
        },
        /**
         * canvas初始化
         */
        initCanvas() {
            this.plinkoGames = new PlinkoGame.PlinkoInit();
            if (!this.plinkoGames.init(this.$refs.plinkoCanvas)) return;
            this.plinkoGames.newGame(this.rowsModel);
            this.updateTimer = handleSetInterval(
                function () {
                    this.hasBall = this.plinkoGames.update(this.settingStore.animation);
                }.bind(this),
                1e3 / 45,
            ); // 30fps -> 45fps
        },

        /**
         * 页面尺寸变化
         */
        handleResize() {
            const plinkoStore = usePlinkoStore();
            window.addEventListener(
                'resize',
                function () {
                    if (this.plinkoGames.checkResize()) {
                        this.plinkoGames.newGame(this.rowsModel);
                        // this.stageHasBall = false;
                        plinkoStore.stageHasBall = false;
                    }
                }.bind(this, ...arguments),
            );
        },
        // ↓ 自动模式输入面板“窗口化改造” 添加的变量与方法：
        toChangeMode(isAuto) {
            // ↓按各个游戏的实际情况设定
            this.settingStore.game.plinko.auto.default = !!isAuto;
            if (isAuto) {
                this.autoDialog.switchAutoDialogVisible(true);
            }
        },
        /**
         * 监听jackpot赢分
         */
        handleOnWinJackpot() {
            const { ON_WINJACKPOT } = useJackPotSocket();
            this.jackpotListeningStoper = ON_WINJACKPOT('plinko', (res) => {
                if (res.jackpot.user.username === this.userStore.name) {
                    this.winJackpotData = {
                        ...res.jackpot,
                        game: 'plinko',
                    };
                }
            });
        },
    },
});
</script>

<style lang="scss" scoped>
.plinko-game {
    line-height: normal;
    padding: 0 0 34px;
    width: calc(100% + 1.5rem);
    margin-left: -0.75rem;

    .button-operation {
        width: 100%;
        max-width: 650px;
        margin: 0 auto;

        .button-settings {
            cursor: pointer;
            display: flex;
            justify-content: flex-end;
            margin-bottom: 12px;
            margin-top: 2px;
            width: 100%;

            & > :deep(div) {
                flex: none;

                &:not(:last-child) {
                    margin-right: 5px;
                }
            }
        }

        @media (max-width: 1000px) {
            .button-settings {
                justify-content: flex-start;

                & > :deep(div) {
                    flex: 1;
                }
            }
        }
    }

    .plinko-main {
        margin: 0 auto;
        padding-left: 0;
        padding-right: 0;
        position: relative;
        width: 100%;
    }

    @media (max-width: 768px) {
        .plinko-main {
            padding-left: 16px;
            padding-right: 16px;
        }
    }

    @media (max-width: 1000px) {
        .plinko-main {
            padding-left: 16px;
            padding-right: 16px;
        }
    }

    @media (max-width: 1093px) {
        .plinko-main {
            padding-left: 16px;
            padding-right: 16px;
        }
    }

    @media (max-width: 1108px) {
        .plinko-main {
            padding-left: 16px;
            padding-right: 16px;
        }
    }

    @media (max-width: 1325px) {
        .plinko-main {
            padding-left: 16px;
            padding-right: 16px;
        }
    }

    @media (max-width: 1340px) {
        .plinko-main {
            padding-left: 16px;
            padding-right: 16px;
        }
    }

    .plinko-content {
        width: 100%;
        max-width: 650px;
        margin: 0 auto;
        background-size: cover;
        border-radius: 21px;
        position: relative;
        user-select: none;

        .game-field {
            width: 100%;
            border-radius: 21px;
            margin-bottom: 20px;
            overflow: hidden;
            position: relative;

            .game-bg {
                display: block;
                width: 100%;
                content: url('@/assets/webp/canvas-bg-sm.webp');
                pointer-events: none;
            }

            #plinko {
                width: 100%;
                height: 100%;
                bottom: 0;
                left: 0;
                position: absolute;
                right: 0;
                top: 0;
            }
        }

        @media (max-width: 460px) {
            .game-field {
                border-radius: 0;
                margin-bottom: 17%;
                transform: scale(1.1);
                transform-origin: top center;
            }
        }
    }

    .plinko-maxwin {
        backdrop-filter: blur(2px);
        background: rgba(14, 38, 69, 0.8);
        border: 1px solid #1a314d;
        border-radius: 6px;
        color: #93acd3;
        font-size: 11px;
        font-weight: 600;
        left: 50%;
        letter-spacing: -0.02em;
        line-height: 16px;
        padding: 4px 8px;
        position: absolute;
        top: 10%;
        transform: translate(-50%);
        z-index: 2;

        span {
            color: #fff;
            font-size: 12px;
        }
    }

    .game-container {
        display: flex;
        justify-content: center;
    }

    .game-body {
        width: 100%;
        max-width: 650px;
        display: flex;
        height: 10.6%;
        align-items: center;
    }
    .auto-section {
        margin-top: 22px;
        padding: 0 20px;
        @media (max-width: 1100px) {
            margin-bottom: 0;
            margin-top: 15px;
        }
        @media (max-width: 576px) {
            margin-top: 7px;
        }
    }
}

@media (max-width: 1000px) {
    .plinko-game {
        padding-bottom: 0px;
        padding-top: 0px;
    }
}

@media (max-width: 768px) {
    .plinko-game {
        padding-bottom: 0px;
        padding-top: 3px;
    }
}

.line-34 {
    line-height: 34px;
}

.current-multi {
    animation-name: moveTo;
    animation-duration: 0.5s;
}
.text-label {
    color: #55657e;
    display: block;
    font-size: 15px;
    line-height: 14px;
    padding-bottom: 8px;
    text-transform: uppercase;
    font-weight: 500;
}
@keyframes moveTo {
    0% {
        transform: translateY(0px);
    }

    50% {
        transform: translateY(5px);
    }

    100% {
        transform: translateY(0px);
    }
}
</style>